module.exports = __webpack_public_path__ + "static/img/ent-23.cd91f1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-23.jpg
// module id = AzPH
// module chunks = 52